import styled from 'styled-components';

export const TabsWrapper = styled.div`
    .nav > li > a,
    .nav > li.active > a {
        font-size: 14px !important;
        color: #006;
    }

    .nav > li.active > a {
        background-color: #ccc !important;
    }

    .nav > li.on > a {
        background-color: white;
    }
`;

export const PillWrapper = styled.li`
    & > a {
        //padding: 3px 7px !important;
        border: ${p => p.className == null ? "1px solid darkgrey !important" : "1px solid #337ab7"};
    }

    margin-right: 5px;
`